import React from "react";
import { useEffect } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from "@mui/material/Button";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../config/config";

export default function Login() {
  const [showPassword, setShowPassword] = React.useState(false);
  const [login_id, setLogin_id] = React.useState("");
  const [password, setPassword] = React.useState("");
  const navigate = useNavigate();

  // Redirect to Home if token exists
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = () => {
    const response = axios.post(`${config.baseUrl}/User/login`, {
      login_id: login_id,
      password: password
    })
      .then((response) => {
        console.log(response);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("user_id", response.data.userId);
        localStorage.setItem("username", response.data.name);
        localStorage.setItem("img", response.data.img);

        navigate("/");
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "Incorrect Credentials", "error");
      });

  }


  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography
              variant="h5"
              component="div"
              textAlign={"center"}
              fontWeight={"bold"}
            >
              Login
              <hr />
            </Typography>
            <TextField
              id="standard-basic"
              label="Username"
              variant="standard"
              fullWidth
              onChange={(e) => setLogin_id(e.target.value)}
            />
            <FormControl sx={{ mt: 2, width: '100%' }} variant="standard">
              <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
              <Input
                id="standard-adornment-password"
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword ? 'hide the password' : 'display the password'
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Button variant="contained" color="success" sx={{ mt: 2, width: '100%' }} onClick={handleLogin}>Login</Button>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
}
